import {
	ResponsiveContainer,
	ComposedChart,
	XAxis,
	YAxis,
	Bar,
	Line,
	LabelList,
	Tooltip,
	BarChart,
	Legend,
} from "recharts";
import { numberFormatter } from "../../utils";
interface Props {
	chartData: Array<T>;
	spendText: any;
}
interface T {
	quarter: string;
	actual: number;
	forecastedSpend: number;
	spendNeededForNextTier: number;
	spendShift: number;
	targetGrowthSpend: number;
}
const SpendChartNIASimulator = (props: Props) => {
	let data = props?.chartData;
	const footerData = [
		{ category: "actualSales" },
		{ category: "forecasetdSales" },
		{ category: "additionalPurchases" },
		{ category: "salesMovementFromPeers" },
		{ category: "targetGrowthSales" },
		{ category: "lastYear" },
	];
	const updateFill = (category: any) => {
		switch (category) {
			case "actualSales":
				return "#3B60A0";
			case "forecasetdSales":
				return "#86BC25";
			case "additionalPurchases":
				return "#012169";
			case "salesMovementFromPeers":
				return "#0097A9";
			case "targetGrowthSales":
				return "#5EC1C8";
			case "lastYear":
				return "#DA505582";
			default:
				return "#000";
		}
	};

	const updateLegend = (category: any) => {
		switch (category) {
			case "actualSales":
				return `Actual `;
			case "forecasetdSales":
				return `Forecasted ($)`;
			case "additionalPurchases":
				return `Additional Purchases ($)`;
			case "salesMovementFromPeers":
				return ` Movement From Peers($)`;
			case "targetGrowthSales":
				return `Target Growth ($)`;
			case "lastYear":
				return `Last Year ($)`;
			default:
				return category;
		}
	};
	let spendText = props?.spendText;
	data?.map((item: any, index: any) => {
		if (index < props.chartData.length - 2 && props.chartData.length > 2) {
			item.dashedData = null;
		} else if (index === props.chartData.length - 2) {
			item.dashedData = item.lastYear;
		} else {
			if (item.lastYear != null) {
				item.dashedData = item.lastYear;
				item.lastYear = null;
			}
		}
	});
	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">Quarter:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.quarter}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						{data.salesMovementFromPeers > 0 && (
							<p
								className="label"
								style={{ padding: "0", margin: "0" }}
							>
								<label
									className="graph-label-small"
									style={{
										color: "#5a5a5a",
										fontWeight: "normal",
									}}
								>
									{spendText} Movement From Peers($):{" "}
								</label>
								<label
									className="graph-label-small"
									style={{
										color: "#3f3f3f",
										fontWeight: "bold",
									}}
								>
									{numberFormatter(
										data.salesMovementFromPeers,
										0
									)}
								</label>
							</p>
						)}

						{data.forecasetdSales > 0 && (
							<p
								className="label"
								style={{ padding: "0", margin: "0" }}
							>
								<label
									className="graph-label-small"
									style={{
										color: "#5a5a5a",
										fontWeight: "normal",
									}}
								>
									Forecasted {spendText}($):{" "}
								</label>
								<label
									className="graph-label-small"
									style={{
										color: "#3f3f3f",
										fontWeight: "bold",
									}}
								>
									{numberFormatter(data.forecasetdSales, 0)}
								</label>
							</p>
						)}

						{data.additionalPurchases > 0 && (
							<p
								className="label"
								style={{ padding: "0", margin: "0" }}
							>
								<label
									className="graph-label-small"
									style={{
										color: "#5a5a5a",
										fontWeight: "normal",
									}}
								>
									Additional Purchases {spendText} ($):{" "}
								</label>
								<label
									className="graph-label-small"
									style={{
										color: "#3f3f3f",
										fontWeight: "bold",
									}}
								>
									{numberFormatter(
										data.additionalPurchases,
										2
									)}
								</label>
							</p>
						)}

						{(data.forecastedSpend > 0 ||
							data.spendNeededForNextTier > 0) && (
							<>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Forecasted {spendText}($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.forecastedSpend,
											0
										)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										{spendText} Movement From Peers($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.spendMovementFromPeersProporiton,
											0
										)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										{spendText} From Additional
										Purchases($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.additionalPurchaseProporiton,
											0
										)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Target Growth {spendText}($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.targetGrowthSpend,
											0
										)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: "0", margin: "0" }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Last Year {spendText}($):{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(data.dashedData, 2)}
									</label>
								</p>
							</>
						)}
					</div>
				</div>
			);
		}
		return null;
	};

	const renderCustomLegend = (props: any) => {
		const { payload } = props;
		return (
			<ul
				style={{
					listStyleType: "none",
					padding: 0,
					display: "flex",
					flexWrap: "wrap",
					columnGap: "1vh",
					marginLeft: "1vh",
				}}
			>
				{payload.map((entry: any, index: any) =>
					entry.value == "dashedData" ? (
						<></>
					) : (
						<li
							key={`item-${index}`}
							style={{
								display: "flex",
								alignItems: "center",
								marginBottom: 4,
								color: entry.color,
								fontSize: "1.8vh",
							}}
						>
							{entry.value != "Target Growth Sales($)" &&
								entry.value != "Last Year Sales($)" && (
									<div
										style={{
											width: 10,
											height: 10,
											backgroundColor: entry.color,
											marginRight: 8,
										}}
									></div>
								)}
							{entry.value === "Last Year Sales($)" && (
								<span
									style={{
										backgroundColor: entry.color,
										width: "1.5vh",
										height: 2,
										display: "inline-block",
										marginRight: 5,
										top: 0,
										position: "relative",
									}}
								/>
							)}
							{entry.value}
						</li>
					)
				)}
			</ul>
		);
	};
	return (
		<div className="w-full ">
			<div className="headSpace">
				<div className="headContent">{spendText} Trend ($)</div>
			</div>
			<ResponsiveContainer width="90%" height="70%">
				<ComposedChart
					data={data}
					margin={{
						top: 20,
						right: 30,
						left: 30,
					}}
				>
					<XAxis
						dataKey="quarter"
						className="graph-label"
						stroke="black"
					/>
					<YAxis
						className="graph-label"
						tickFormatter={(value: number) =>
							numberFormatter(value, 0, "$")
						}
						stroke="black"
					/>
					<Tooltip
						contentStyle={{
							color: "black",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
						content={customTooltip}
					/>

					<Bar
						dataKey="actualSales"
						name={`Actual ${spendText}($)`}
						stackId="b"
						fill="#3B60A0"
						barSize={40}
					>
						<LabelList
							dataKey="actualSales"
							fill="white"
							className="graph-label"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						dataKey="forecasetdSales"
						name={`Forecasted ${spendText}($)`}
						stackId="b"
						fill="#86BC25"
						barSize={40}
					>
						<LabelList
							dataKey="forecasetdSales"
							fill="white"
							className="graph-label"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						dataKey="additionalPurchases"
						name={`Additional Purchases ${spendText}($)`}
						stackId="b"
						fill="#012169"
						barSize={40}
					>
						{/*  <LabelList
              dataKey="additionalPurchaseProporiton"
              fill="white"
              fontWeight={700}
              fontSize="1.2vh"
              formatter={(value: number) =>
                value == 0 ? null : numberFormatter(value, 0, "$")
              }
              position="center"
            ></LabelList> */}
					</Bar>
					<Bar
						dataKey="salesMovementFromPeers"
						name={`${spendText} Movement From Peers($)`}
						stackId="b"
						fill="#0097A9"
						barSize={40}
					>
						{/*  <LabelList
              dataKey="spendMovementFromPeersProporiton"
              fill="white"
              fontWeight={700}
              fontSize="1.2vh"
              formatter={(value: number) =>
                value == 0 ? null : numberFormatter(value, 0, "$")
              }
              position="center"
            ></LabelList> */}
					</Bar>
					<Bar
						dataKey="targetGrowthSales"
						name={`Target Growth ${spendText}($)`}
						stackId="b"
						fill="#5EC1C8"
						barSize={40}
					>
						<LabelList
							dataKey="targetGrowthSalesLabel"
							fill="#5EC1C8"
							className="graph-label"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 1, "$")
							}
							position="top"
						></LabelList>
					</Bar>
					<Line
						type="linear"
						dataKey="lastYear"
						name={`Last Year ${spendText}($)`}
						stroke="#DA505582"
						strokeDasharray={"0"}
						connectNulls={true}
						strokeWidth={3}
					/>
					<Line
						type="linear"
						dataKey="dashedData"
						stroke="#62B5E582"
						legendType="none"
						strokeDasharray={"3 3"}
						connectNulls={true}
						strokeWidth={3}
					/>
				</ComposedChart>
			</ResponsiveContainer>
			<div className="contentFooter pt-[2vh]">
				<div className="flex flex-wrap items-start gap-x-2 px-4 w-full">
					{footerData.map((entry, index) => (
						<div
							key={`legend-${index}`}
							className="flex items-center min-h-[20px] cursor-pointer"
						>
							<div
								className="w-3 h-3 mr-2"
								style={{
									backgroundColor: updateFill(entry.category),
								}}
							></div>
							<span
								className="text-[0.85em] leading-tight"
								style={{
									color: updateFill(entry.category),
								}}
							>
								{updateLegend(entry.category)}
							</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
export default SpendChartNIASimulator;
